module.exports = __webpack_public_path__ + "img/cloud2_3.e0a693ac.png";